import { Button, Panel, PanelBody, PanelHeader } from "@itandi/itandi-bb-ui";
import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { ConfirmModal } from "~/components/common/parts/modal/ConfirmModal";
import { useCompanyStoreMails } from "~/hooks/useCompanyStoreMails";
import { useOpenHandler } from "~/hooks/useOpenHandler";
import { isSuccess } from "~/utils/api/api_handler";
import { destroy as destroyMails } from "~/utils/api/CompanyStoreMails";
import { CompanyStoreMailList } from "./CompanyStoreMailList";
import { CompanyStoreMailModal } from "./CompanyStoreMailModal";

export function Page() {
	const [checkNumbers, setCheckNumbers] = useState<number[]>([]);
	const { data: companyMails, mutate: mutateMails } =
		useCompanyStoreMails().index();
	const {
		isOpen: openConfirm,
		handleOpen: handleOpenConfirm,
		handleClose: handleCloseConfirm
	} = useOpenHandler();
	const {
		isOpen: openDeleteConfirm,
		handleOpen: handleOpenDeleteConfirm,
		handleClose: handleCloseDeleteConfirm
	} = useOpenHandler();

	const isChecked = checkNumbers.length > 0;

	const handleDestroyMails = useCallback(async () => {
		const result = await destroyMails(checkNumbers);
		if (isSuccess(result)) {
			handleCloseDeleteConfirm();
			await mutateMails();
			setCheckNumbers([]);
			toast.success("削除しました");
		} else {
			toast.error("エラーが発生しました");
		}
	}, [checkNumbers, handleCloseDeleteConfirm, mutateMails]);

	const handleCheckNumbers = useCallback(
		(deleteIds: number) => {
			if (checkNumbers.includes(deleteIds)) {
				setCheckNumbers(checkNumbers.filter((num) => num !== deleteIds));
			} else {
				setCheckNumbers([...checkNumbers, deleteIds]);
			}
		},
		[checkNumbers]
	);

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<Panel>
					<PanelHeader
						rightArea={
							<Button
								onClick={
									isChecked ? handleOpenDeleteConfirm : handleOpenConfirm
								}
								variant={isChecked ? "danger" : "primary"}
							>
								{isChecked ? "選択したメールアドレスを削除する" : "追加"}
							</Button>
						}
						title="通知先メールアドレス設定"
					/>
					<PanelBody>
						<CompanyStoreMailList
							checkNumbers={checkNumbers}
							companyMails={companyMails}
							onCheckChange={handleCheckNumbers}
						/>
					</PanelBody>
				</Panel>
				<ConfirmModal
					confirmType="delete"
					handleAccept={handleDestroyMails}
					handleCancel={handleCloseDeleteConfirm}
					isOpen={openDeleteConfirm}
				>
					選択したメールアドレスを削除してよろしいですか？
				</ConfirmModal>
				<CompanyStoreMailModal
					handleClose={handleCloseConfirm}
					isOpen={openConfirm}
				/>
			</ClientSettingLayout>
		</DefaultV2>
	);
}
